import http from "../../http";

export default {
  web: {
    // 落地页
    info: data => {
      return http.get(
        "/websitecenter/landingpage/netapi/build/template/findOne",
        data
      );
    },
    list: data => {
      return http.post("/websitecenter/landingpage/build/findPage", data);
    },
    save: data => {
      return http.post("/websitecenter/landingpage/build/save", data);
    }
  },
  template: {
    // 落地页页面模板
    list: data => {
      return http.post(
        "/websitecenter/landingpage/landingpage/template/findPage",
        data
      );
    },
    save: data => {
      return http.post(
        "/websitecenter/landingpage/landingpage/template/save",
        data
      );
    }
  },
  element: {
    // 落地页模块模板
    list: data => {
      return http.post(
        "/websitecenter/landingpage/element/template/findPage",
        data
      );
    },
    save: data => {
      return http.post(
        "/websitecenter/landingpage/element/template/save",
        data
      );
    }
  },
  type: {
    add: (params) => {
      return http.post('websitecenter/landingpagesort/add', params)
    },
    update: (params) => {
      return http.put('websitecenter/landingpagesort/update', params)
    },
    list: (params) => {
      return http.get('websitecenter/landingpagesort/tree', params)
    },
    del: (params) => {
      return http.delete('websitecenter/landingpagesort/del/' + params.id, params)
    }
  }
};
